<template>
  <div class="baiduQueue">
    <div class="fromClass2">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item label="姓名">
          <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="roleType" placeholder="请选择角色" clearable>
            <el-option label="全部" :value="0"></el-option>
            <!-- <el-option label="超级管理员" :value="1"></el-option> -->
            <el-option label="销售主管" :value="2"></el-option>
            <el-option label="销售人员" :value="3"></el-option>
            <el-option label="资料审核人员" :value="4"></el-option>
            <el-option label="后台主管" :value="5"></el-option>
            <el-option label="做单人员" :value="6"></el-option>
            <el-option label="贷后主管" :value="7"></el-option>
            <el-option label="贷后管理人员" :value="8"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="add" v-if="accountType==1">新增员工</el-button>
        </el-button-group>
      </div>
      <div>
        <el-button-group>
          <!-- <el-button type="primary" size="small" @click="derive">导出</el-button> -->
          <el-button type="primary" size="small" @click="refresh">查询</el-button>
        </el-button-group>
      </div>
    </div>
    <div class="tableClass">
      <template>
        <el-table
          ref="multipleTable"
          :data="list.list"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
        >
          <el-table-column label="姓名">
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column label="账号名称">
            <template slot-scope="scope">
              {{scope.row.account}}
            </template>
          </el-table-column>
          <el-table-column label="头像">
            <template slot-scope="scope">
              <el-image 
                  style="width: 60px; height: 60px"
                  :src="scope.row.avatar" 
                  :preview-src-list="[scope.row.avatar]">
                </el-image>
            </template>
          </el-table-column>
          <el-table-column label="角色">
            <template slot-scope="scope">
              {{scope.row.role}}
            </template>
          </el-table-column>
          <el-table-column label="所属团队">
            <template slot-scope="scope">
              {{scope.row.team}}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              {{scope.row.status}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              {{scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" v-if="![3, 6, 8].includes(accountType)">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="updatePassword(scope.row)"
                >修改密码</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.status=='正常'"
                  @click="setStatus(scope.row,'禁用')"
                >禁用账号</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.status=='禁用'"
                  @click="setStatus(scope.row,'正常')"
                >解禁账号</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="updateTeam(scope.row)"
                  v-if="[3].includes(scope.row.roleType)"
                  style="margin-top: 10px;margin-left: 0 !important;"
                >更换团队</el-button>
                <el-button
                  type="danger"
                  size="mini"
                  v-if="scope.row.status=='禁用'"
                  @click="setStatus(scope.row,'删除')"
                >删除账号</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="1"
          :page-sizes="[10,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.totalRow"
          size="small"
        ></el-pagination>
      </template>
    </div>
    <el-dialog
      :title="form.id?'编辑员工':'新增员工'"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="account">
          <el-input v-model="form.account"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleType">
          <el-select v-model="form.roleType"   clearable   @change="roleTypeChange">
            <!-- <el-option label="超级管理员" :value="1"></el-option> -->
            <el-option label="销售主管" :value="2"></el-option>
            <el-option label="销售人员" :value="3"></el-option>
            <el-option label="资料审核人员" :value="4"></el-option>
            <el-option label="后台主管" :value="5"></el-option>
            <el-option label="做单人员" :value="6"></el-option>
            <el-option label="贷后主管" :value="7"></el-option>
            <el-option label="贷后管理人员" :value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级" prop="pId" v-if="[3, 6, 8].includes(form.roleType)">
          <el-select v-model="form.pId"   clearable  >
            <el-option :label="item.name" :value="item.pId" v-for="(item,index) in parentList" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="更换团队"
      :visible.sync="updateTeamShow"
      width="500px"
      :before-close="handleClose">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="可选团队" prop="teamId">
          <el-select v-model="form.teamId"   clearable  >
            <el-option :label="item.name" :value="item.teamId" v-for="(item,index) in parentList" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="updateTeamSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="updatePasswordShow"
      width="500px"
      :before-close="handleClose">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="updatePasswordSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  title: "课程列表",
  data() {
    return {
      accountType:'',
      roleType: "",
      page: 1,
      pageSize:10,
      name: "",
      list:{
      },
      parentList:[],
      dialogVisible:false,
      updatePasswordShow:false,
      updateTeamShow:false,
      form:{
        account:'',
        password:'',
        roleType:'',
        name:'',
        teamId:'',
        pId:''
      },
      rules:{
        account: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        roleType: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        pId: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      }
    };
  },
  computed: {
  },
  components: {},
  filters: {
    date1(e) {
      let date = new Date(e);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
      );
    }
  },
  methods: {
    setStatus(e,index){
      this.$confirm(`确定${index}该员工吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            adminId:e.id,
          };
          if(index=='禁用'){
            this.$axios.post('/api/admin/disable',this.$qs.stringify(params)).then(res=>{
                if (res.data.code == 1) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.getData()
                }else{
                  this.$message.error(res.data.msg);
                }
            })
          }else if(index=='正常'){
            this.$axios.post('/api/admin/unban',this.$qs.stringify(params)).then(res=>{
                if (res.data.code == 1) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.getData()
                }else{
                  this.$message.error(res.data.msg);
                }
            })
          }else if(index=='删除'){
            this.$axios.post('/api/admin/del',this.$qs.stringify(params)).then(res=>{
                if (res.data.code == 1) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.getData()
                }else{
                  this.$message.error(res.data.msg);
                }
            })
          }
          
        })
        .catch(() => {});
    },
    // 更换团队————————————————————————————————————————————————————————
    updateTeamSubmit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params={
            adminId:this.form.id,
            teamId:this.form.teamId
          }
          this.$axios.post('/api/admin/changeTeam',this.$qs.stringify(params)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData()
                this.handleClose()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updateTeam(e){
      this.form.id=e.id
      let params = {
        adminId:e.id
      };
      this.$axios.post('/api/admin/allTeam',this.$qs.stringify(params)).then(res=>{
          this.parentList=res.data.data
          this.updateTeamShow=true
      })
    },
    // 修改密码————————————————————————————————————————————————————————
    updatePassword(e){
      this.form.id=e.id
      this.updatePasswordShow=true
    },
    updatePasswordSubmit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params={
            adminId:this.form.id,
            password:this.form.password
          }
          this.$axios.post('/api/admin/changePassword',this.$qs.stringify(params)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData()
                this.handleClose()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 添加员工——————————————————————————————————————————————————
    add(){
      this.setData()
      this.dialogVisible=true
    },
    handleClose(){
      this.setData()
      this.dialogVisible=false
      this.updatePasswordShow=false
      this.updateTeamShow=false
    },  
    setData(){
      this.form={
        account:'',
        password:'',
        roleType:'',
        name:'',
        pId:''
      }
    },
    submit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/admin/add',this.$qs.stringify(this.form)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData()
                this.handleClose()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    roleTypeChange(e){
      const arr = [3, 6, 8];
      if(!arr.includes(e)){
        return
      }
      let params = {
        roleType:e
      };
      this.$axios.post('/api/admin/getParent',this.$qs.stringify(params)).then(res=>{
          this.parentList=res.data.data
      })
    },
    // 查询列表————————————————————————————————————————————————————————
    derive(){
      let params = {
        page:this.page,
        pageSize:this.pageSize,
        name:this.name,
        roleType:this.roleType
      };
      this.$axios.post('/api/admin/getList',this.$qs.stringify(params)).then(res=>{
        if (res.data.code == 1){
          const a = document.createElement('a'); // 创建一个HTML 元素
          let url = res.data.data;
          a.setAttribute('download', ''); //download属性
          a.setAttribute('href', url); // href链接
          a.click();
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    getRowKeys(row) {
      return row.id;
    },
    handleSelectionChange(e) {
      this.ids = [];
      for (let i = 0; i < e.length; i++) {
        this.ids.push(e[i].id);
      }
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    refresh() {
      this.page = 1;
      this.getData();
    },
    getData() {
      let params = {
        page:this.page,
        pageSize:this.pageSize,
        name:this.name,
        roleType:this.roleType
      };
      this.$axios.post('/api/admin/getList',this.$qs.stringify(params)).then(res=>{
          this.list=res.data.data
      })
      
    }
  },

  mounted() {
    this.getData();
    this.accountType=Cookie.get('roleType')
  }
};
</script>  
<style lang="scss" scoped>
.flex{
  display: flex;
  align-items: center;
  img{
    width: 100px;
    height: 100px;
    margin-right: 50px;
  }
  
}
.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.baiduQueue {
  width: calc(100% - 40px);
  padding: 20px 0;
  min-height: 680px;
  .userNumber {
    width: 90%;
    height: 30px;
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    & > div {
      font-size: 12px;
      color: gray;
      margin-top: 10px;
      span {
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
  .fromClass2 {
    width: 90%;
    height: auto;
    margin: 10px auto;
    padding: 10px 0;
    display: flex;

    align-content: center;
  }
  .tableClass {
    width: 90%;
    margin: 0 auto;
  }
  //   .el-dialog__body{
  //       padding: 10px 20px;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //   }
}
.btn {
  width: 90%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.initializeTitle {
  font-size: 14px;
  color: gray;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.el-dialog__body {
  padding: 20px;
}
.hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  height: 23px !important;
}
.tableImg {
  width: 34px;
  height: 34px;
}
</style>  


// WEBPACK FOOTER //
// src/pages/user/index.vue